import { Component, OnInit } from '@angular/core';
import { IFact } from '../../shared/classes/fact';
import { SystemService } from '../../services/system.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

@Component({
  templateUrl: './facts.component.html'
})
export class FactsComponent implements OnInit {
    factList: IFact[];
    myFact: IFact = {
        id: 0,
        letter: '',
        fact: ''
    };

    isNewEntry = false;
    userType = '';

    displayState: any = {
        workingDiv: false,
        factDiv: false,
        gridDiv: true,
        editFactDiv: false,
        saveDisabled: false
    };


    constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

    ngOnInit() {
        this.displayState.gridDiv = true;
        this.displayState.factDiv = false;
        this.displayState.editUserDiv = false;
        this.loadFactList();
    }

    loadFactList() {
        this.displayState.workingDiv = true;
        this.systemService.getFactList().subscribe (data => {
            this.factList = [];
            this.factList = data;
            this.displayState.workingDiv = false;
        });
    }

    onSelect(fact: IFact) {
        // get the fact data; from grid or from API call??
        //
        // now, display the edit Fact form
        this.displayState.gridDiv = false;
        this.displayState.factDiv = true;
        this.isNewEntry = false;
        // set Fact data for display
        this.myFact.id = fact.id;
        this.myFact.letter = fact.letter;
        this.myFact.fact = fact.fact;
        //
        this.displayState.editFactDiv = true;
        return true;
    }

    newFact() {
        this.displayState.gridDiv = false;
        this.displayState.factDiv = true;
        this.isNewEntry = true;
        this.displayState.editFactDiv = true;
        // set fact data for display
        this.myFact.id = 0;
        this.myFact.letter = '';
        this.myFact.fact = '';
        //
        return true;
    }

  saveFact() {
    // validate data...
    if (this.validateFactData() === false ) {
      this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
      return true;
    }
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    // save fact data
    this.systemService.saveFact(this.myFact).subscribe (data => {
      // once we get a response, hide the Edit window
      this.displayState.factDiv = false;
      this.displayState.editFactDiv = false;
      this.displayState.saveDisabled = false;
      // display grid div
      this.displayState.gridDiv = true;
      this.showToast({severity: 'success', summary: '', detail: 'Fact data updated.'});
      // refresh the grid/list
      this.loadFactList();
    });

    //
    return true;
  }

  validateFactData() {
    // validate required fact data; base it on value of any element w/ prd-required class??
    if ((this.myFact.letter === '') || (this.myFact.fact === '')) {
      return false;
    }
    return true;
  }

  deleteFact(fact: IFact) {
    this.confirmationService.confirm({
        message: 'Do you want to delete this record?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.systemService.deleteFact(fact).subscribe(data => {
            this.showToast({severity: 'success', detail: 'Fact has been DELETED.', summary: ''});
            this.loadFactList();
          });
        },
        reject: () => {
          this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
    });

    return true;
  }

  cancelEntry() {
    this.displayState.factDiv = false;
    this.displayState.editFactDiv = false;
    this.displayState.gridDiv = true;
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }

}
